import { SearchOrder } from '@/features/questions-page/SearchOrder/ui/SearchOrder.jsx'
import './ui/SearchOrder.scss'
export default SearchOrder
